var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.88 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "view") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.44,15A11.06,11.06,0,0,1,.13,7.85L0,7.5l.13-.35A11.06,11.06,0,0,1,10.44,0a10.92,10.92,0,0,1,7.78,3.22,11.09,11.09,0,0,1,2.52,3.93l.14.35-.14.35a11.09,11.09,0,0,1-2.52,3.93A10.92,10.92,0,0,1,10.44,15ZM2.14,7.5a9.08,9.08,0,0,0,8.3,5.5,8.94,8.94,0,0,0,6.36-2.64A9,9,0,0,0,18.73,7.5a9,9,0,0,0-16.59,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.67,4.38l-.16.27a4,4,0,0,0-.59,2.53A2.51,2.51,0,0,1,11,9.93,2.51,2.51,0,0,1,8,7.17,2.55,2.55,0,0,1,9.22,5.34a2.87,2.87,0,0,1,.51-.23A4,4,0,0,0,12,3.29h0a4.16,4.16,0,0,0-3.37.14A4.65,4.65,0,0,0,5.94,7.29a4.5,4.5,0,0,0,8.93,1A4.45,4.45,0,0,0,13.67,4.38Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconView);
export default __webpack_public_path__ + "static/media/icon-view.317d4ddbfd0674e0f9073aa8b041af23.svg";
export { ForwardRef as ReactComponent };